import {DataSource} from '@angular/cdk/table';
import {BehaviorSubject, merge as observableMerge, Observable, SubscriptionLike as ISubscription} from 'rxjs';
import { MatSort } from '@angular/material/sort';
import {map} from 'rxjs/operators';

export class TenderDataSource extends DataSource<any> {
  private totalRows: number;
  private dataChange: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private subscription: ISubscription;

  _filterChange = new BehaviorSubject('');
  get filter(): string {
    return this._filterChange.value;
  }
  set filter(filter: string) {
    this._filterChange.next(filter);
  }

  get data(): any[] {
    return this.dataChange.value;
  }

  get rows(): number {
    return this.totalRows;
  }

  constructor(private tenders: BehaviorSubject<any[]>, private _sort: MatSort) {
    super();
    this.subscription = tenders.subscribe(res => {
      const orderList: any[] = res;
      this.dataChange.next(orderList);
      this.totalRows = orderList.length;
    });
  }

  connect(): Observable<any[]> {
    const displayDataChanges = [this.dataChange, this._filterChange, this._sort.sortChange];

    return observableMerge(...displayDataChanges).pipe(
      map(() => {
        return this.data;
      })
    );
  }

  getSortedData(): any[] {
    const data = this.data.slice().filter((item: any) => {
      const searchStr = '';
      return searchStr.indexOf(this.filter.toLowerCase()) !== -1;
    });
    if (!this._sort.active || this._sort.direction === '') {
      return data;
    }

    const orderNullList = [];
    const orderList = [];

    data.forEach((el) => {
      switch (this._sort.active) {
        case 'reference':
          if (el.referentie === null || el.referentie === '' ) {
            orderNullList.push(el);
          } else {
            orderList.push(el);
          }
          break;
        case 'numberplate':
          if (el.license_plate === null || el.license_plate === '' ) {
            orderNullList.push(el);
          } else {
            orderList.push(el);
          }
          break;
        default:
          orderList.push(el);
          break;
      }
    });

    return orderList.sort((a, b) => {

      let propertyA: number | string = '';
      let propertyB: number | string = '';

      switch (this._sort.active) {
        case 'reference':
          [propertyA, propertyB] = [a.referentie.toLowerCase(), b.referentie.toLowerCase()];
          break;
        case 'owner_name':
          [propertyA, propertyB] = [`${a.__user__.firstname.toLowerCase()} ${a.__user__.lastname.toLowerCase()}`,
            `${b.__user__.firstname.toLowerCase()} ${b.__user__.lastname.toLowerCase()}`];
          break;
        case 'numberplate':
          [propertyA, propertyB] = [a.license_plate.toLowerCase(), b.license_plate.toLowerCase()];
          break;
        case 'vehicle':
          [propertyA, propertyB] = [a.__standardization__.__car__.name.toLowerCase(), b.__standardization__.__car__.name.toLowerCase()];
          break;
        case 'status':
          [propertyA, propertyB] = [a.status.toLowerCase(), b.status.toLowerCase()];
          break;
      }

      const valueA = isNaN(+propertyA) ? propertyA : +propertyA;
      const valueB = isNaN(+propertyB) ? propertyB : +propertyB;


      return (valueA < valueB ? -1 : 1) * (this._sort.direction === 'asc' ? 1 : -1);
    }).concat(orderNullList);
  }

  disconnect() {
    this.subscription.unsubscribe();
  }
}
